import { useQuery } from '@apollo/client';
import { GET_METRIC_GRAPH } from '../gqlSchemes/getMetricGraph';

const useGetMetricsGraph = ({ patient, metricDefinitionId, filter }) => {
  const { loading, error, data, refetch } = useQuery(GET_METRIC_GRAPH, {
    variables: {
      patient,
      metricDefinitionId,
      filter: {
        ...filter,
        startDateTime: filter.startDateTime.split('T')[0] + 'T00:00:00Z',
        endDateTime: filter.endDateTime.split('T')[0] + 'T23:59:59Z',
      },
    },
  });

  if (data?.metric?.metric?.patientMetricGraph) {
    return {
      data: data?.metric?.metric?.patientMetricGraph,
      loading,
      refetch,
    };
  } else {
    return {
      error,
    };
  }
};

export default useGetMetricsGraph;
